<div class="modals payment" [class.modals-show]="isModalPaymentShow" [class.modals-hide]="!isModalPaymentShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <h3>Повідомлення про оплату</h3>

  <div class="row pay_notify">
    <div class="column">
      <p class="payment-label-pay-card">На реквізит: </p>
      <select
        class="pay-card"
        [class.input-error]="payment.pay_card_error"
        [(ngModel)]="payment.pay_card"
        (change)="onPayCardChange()"
      >
        <option value="">Вибрати реквізит</option>
        <option *ngFor="let card of cards" value="{{card.id}}">
          <ng-container *ngIf="card.req_type === 'card_req'">
            {{ card.full_name }} {{ card.bank_name }} {{ card.card_number_hidden }}
          </ng-container>
          <ng-container *ngIf="card.req_type === 'fop_req'">
            {{ card.full_name }} {{ card.bank_name }} {{ card.card_number_hidden }}
          </ng-container>
          <ng-container *ngIf="card.req_type === 'cash'">
            {{ card.full_name }} {{ card.bank_name }} {{ card.card_number_hidden }}
          </ng-container>
          <ng-container *ngIf="card.req_type === 'bank_req'">
            {{ card.organization }}, {{ card.bank_name }}, IBAN: {{ card.iban }}, МФО: {{ card.mfo }},
            ЕДРПОУ: {{ card.edrpou }}
          </ng-container>
        </option>
      </select>
      <span class="status-input-hide" [class.div-input-error]="payment.pay_card_error">
        Виберіть реквізит
      </span>

      <div *ngIf="payment.pay_card && selectedCardFop?.req_type === 'fop_req'" style="margin-top: 8px">
        <select
          class="pay-card"
          [class.input-error]="payment.choused_key_error"
          [(ngModel)]="payment.choused_key"
          (change)="onFopRouteChange()"
        >
          <option value="">Оберіть Карту або IBAN</option>
          <option value="key" *ngIf="selectedCardFop?.card_number">
            Карта: {{ selectedCardFop?.card_number }}
          </option>
          <option value="iban" *ngIf="selectedCardFop?.iban">
            IBAN: {{ selectedCardFop?.iban }}
          </option>
        </select>
        <span class="status-input-hide" [class.div-input-error]="payment.choused_key_error">
          Оберіть Карту або IBAN
        </span>
      </div>
    </div>
  </div>

  <div class="row pay_notify">
    <div class="column">
      <p class="payment-label-pay-card">Сума:</p>
      <span class="style-input-sum">
           <input
             type="number"
             class="expanded pay-summa"
             [(ngModel)]="payment.pay_summa"
             [class.input-error]="payment.pay_summa_error"
             (input)="paySummaValidation()"
           >
      <select
        class="pay-currency"
        [(ngModel)]="payment.pay_currency"
      >
        <option value="{{cur.id}}" *ngFor="let cur of getCurrencies">{{ cur.name }}</option>
      </select>
      </span>

      <span class="status-input-hide" [class.div-input-error]="payment.pay_summa_error">
        Вкажіть суму
      </span>
    </div>
  </div>

  <ng-container *ngIf="ordersForPay && ordersForPay.length">
    <div class="pay-orders" [class.input-error]="!checkedOrder">
      <div class="column" *ngFor="let order of ordersForPay">
        <div class="flex-container">
          <label>
            {{ order.courier }} {{ order.id }}
            від {{ order.date }}
            на суму {{ order.summa }}EUR
            ({{ order.summa_rate }}грн)
          </label>
          <input
            type="checkbox"
            [(ngModel)]="order.isOrderChecked"
            (change)="orderCheckedValidation()"
          >
        </div>
      </div>
    </div>
    <span class="status-input-hide" [class.div-input-error]="!checkedOrder">Виберіть замовлення</span>
  </ng-container>

  <div class="row pay_notify">
    <div class="column">
      <p class="payment-label-pay-card">Коментар:</p>
      <textarea
        class="payment-comment" placeholder="№ декларації / № переказу / коментар"
        [class.input-error]="payment.pay_comment_error"
        [(ngModel)]="payment.comment"
        (input)="commentValidation()"
        rows="5"
      ></textarea>
      <span class="status-input-hide" [class.div-input-error]="payment.pay_comment_error">
        Вкажіть коментар
      </span>
    </div>
  </div>

  <div class="row">
    <div class="column"></div>
    <div class="column shrink">
      <button class="button-payment" [disabled]="isSendingPayNotify" (click)="sendPayment()">Відправити</button>
    </div>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
